import React from "react";
import scan from '../images/scan.gif'
import PleaseMessage from '../images/PleaseMessage.png'
import btnHome from '../images/btnHomeIcon.png'
import TextLoop from "react-text-loop";

const Main = () => {
  return (
    <div className="topicSection">

      {/* HOME BUTTON SECTION */}
      <div className="btnHomeSection bounce-in-fwd10">
        <button type="button" className="btnCircle">
          <img src={btnHome} alt="Date" height="50" width="50" /><br />
               HOME
            </button>
      </div>


      <div className="headerSub">
        <div className="headerSubTitle TextBig tracking-in-contract">
          <p>
            <TextLoop springConfig={{ stiffness: 140, damping: 8 }}>
              <span>WELCOME</span>
              <span>歡迎</span>
              <span>SELAMAT DATANG</span>
              <span>வரவேற்பு</span>
            </TextLoop> 
          </p>
        </div>
      </div>

      <div className="headerName">
        <div className="headerTitle">
          {/* <h1>
            <div className="iconWard"></div>
            WARD VISIT
            </h1> */}
        </div>
      </div>


      {/* MAIN CONTENT SECTION */}
      <div className="contentPage">

        {/* PLEASE MESSAGE  */}
        <div className="languageMessage fade-in-left3">
          <img src={PleaseMessage} alt="choose" height="auto" width="auto" />
        </div>


        {/* ICON BOX */}
        <div className="iconSection iconCenter flip-in-hor-top2">
          <img src={scan} alt="choose" height="600" width="600" />
        </div>


        {/* SCROLLING MESSEGE */}
        <div className="scrollingSection slide-in-bottom3">
          <marquee behavior="scroll" direction="left">Here is some scrolling text... right to left!</marquee>
        </div>


      </div>

    </div>
  );
};

export default Main;